import { useMemo } from "react";
import type { ConditionConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField, ReportField, RunChartReportRequest } from "../../../../../../../../api/types/svTypes.ts";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";

interface Props {
  values: ReportField[];
  isQueryLoggingActive: boolean | undefined;
  sessionId: string;
}
export function useRequestConfigViewer({ isQueryLoggingActive, values, sessionId }: Props) {
  const { reportId, conditions } = useBiCommonDataContext();

  const requestConfig = useMemo(() => {
    const request: RunChartReportRequest = {
      reportId: reportId || "",
      sessionId,
      withDrilldown: true,
      conditions: getConditions(conditions, values),
      useQueryLogging: isQueryLoggingActive === true,
    };
    return request;
  }, [reportId, sessionId, conditions, values, isQueryLoggingActive]);

  return { requestConfig };
}

function getConditions(allConditions: ConditionField[], values: ReportField[]) {
  const customConditions = values
    .filter((f) => f.config?.useCustomConditions && f.config?.customConditions)
    .map((f) => f.config?.customConditions)
    .flat()
    .filter((c): c is ConditionConfiguration => c !== undefined);

  const conditions = [...allConditions.map((c) => c.config), ...customConditions].filter((c) => c.parameter === true);

  return conditions;
}
